/**
 * Network Log Store
 *
 * In-memory circular buffer for API request/response logs.
 * NOT persisted — network logs are session-only.
 * Consumed by the Debug Panel's Network tab.
 */

import { createWithEqualityFn } from 'zustand/traditional'
import { shallow } from 'zustand/shallow'

export interface NetworkLogEntry {
  id: string
  timestamp: number
  method: string
  url: string
  status: number | null
  duration: number | null
  responseSize: number | null
  error?: string
}

interface NetworkLogState {
  entries: NetworkLogEntry[]
  isRecording: boolean
}

interface NetworkLogActions {
  addEntry: (entry: NetworkLogEntry) => void
  clearEntries: () => void
  toggleRecording: () => void
}

type NetworkLogStore = NetworkLogState & NetworkLogActions

const MAX_ENTRIES = 100

export const useNetworkLogStore = createWithEqualityFn<NetworkLogStore>((set, get) => ({
  entries: [],
  isRecording: true,

  addEntry: (entry) => {
    if (!get().isRecording) return
    set((s) => ({
      entries: [entry, ...s.entries].slice(0, MAX_ENTRIES),
    }))
  },

  clearEntries: () => set({ entries: [] }),

  toggleRecording: () => set((s) => ({ isRecording: !s.isRecording })),
}), shallow)
